"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const audience_1 = require("modules/audience");
const broadcastManager_1 = require("modules/broadcastManager");
const classManager_1 = require("modules/classManager");
const community_1 = require("modules/community");
const configManager_1 = require("modules/configManager");
const content_1 = require("modules/content");
const webinar_1 = require("modules/content/components/webinar");
const stores_1 = require("modules/content/dripping/stores");
const quiz_1 = require("modules/content/quiz");
const TrackStore_1 = __importDefault(require("modules/content/tracks/TrackStore"));
const TrackViewStore_1 = __importDefault(require("modules/content/tracks/view/TrackViewStore"));
const stores_2 = require("modules/contentImport/stores");
const dashboard_1 = require("modules/dashboard");
const featureToggle_1 = require("modules/featureToggle");
const membership_1 = require("modules/membership");
const membershipEvent_1 = require("modules/membershipEvent");
const navigation_1 = require("modules/navigation");
const notification_1 = require("modules/notification");
const player_1 = require("modules/player");
const playerBackoffice_1 = require("modules/playerBackoffice");
const product_1 = require("modules/product");
const salesManager_1 = require("modules/salesManager");
const subtitle_1 = require("modules/subtitle");
const testAB_1 = require("modules/testAB");
const ui_1 = require("modules/ui");
const user_1 = require("modules/user");
const userManager_1 = require("modules/userManager");
const Stores = {
    AdvertisementEditorStore: content_1.AdvertisementEditorStore,
    BroadcastStore: broadcastManager_1.BroadcastStore,
    ClassesStore: content_1.ClassesStore,
    ClassStore: classManager_1.ClassStore,
    CommunityStore: community_1.CommunityStore,
    ConfigStore: configManager_1.ConfigStore,
    ContentOnboardingStore: content_1.ContentOnboardingStore,
    ContentPageStore: content_1.ContentPageStore,
    ContentStore: content_1.ContentStore,
    DashboardStore: dashboard_1.DashboardStore,
    DeepSearchStore: userManager_1.DeepSearchStore,
    ExtensionsUserInfoStore: audience_1.ExtensionsUserInfoStore,
    FeatureToggleStore: featureToggle_1.FeatureToggleStore,
    LiveStore: webinar_1.LiveStore,
    MembershipEventStore: membershipEvent_1.MembershipEventStore,
    MembershipStore: membership_1.MembershipStore,
    ModuleEditorStore: content_1.ModuleEditorStore,
    NavStore: navigation_1.NavStore,
    NotificationStore: notification_1.NotificationStore,
    PlayerBackofficeStore: playerBackoffice_1.PlayerBackofficeStore,
    PlayerStore: player_1.PlayerStore,
    ProductStore: product_1.ProductStore,
    QuizStore: quiz_1.QuizStore,
    SalesStore: salesManager_1.SalesStore,
    SeasonStore: content_1.SeasonStore,
    StreamingStore: configManager_1.StreamingStore,
    SubtitleStore: subtitle_1.SubtitleStore,
    TestABStore: testAB_1.TestABStore,
    TrackStore: TrackStore_1.default,
    TrackViewStore: TrackViewStore_1.default,
    UiStore: ui_1.UiStore,
    UserManagerStore: userManager_1.UserManagerStore,
    UserSegmentationStore: userManager_1.UserSegmentationStore,
    UserStore: user_1.UserStore,
    ContentImportProductStore: stores_2.ContentImportProductStore,
    ContentImportModulesStore: stores_2.ContentImportModulesStore,
    DrippingStore: stores_1.DrippingStore,
    DrippingFormStore: stores_1.DrippingFormStore,
    BulkDrippingStore: stores_1.BulkDrippingStore
};
exports.default = Stores;
